import type { SensitiveValue } from "./propertyValueResource";
import type { ResourceWithId } from "./resource";
export interface SmtpCredentialDetailsResource {
    CredentialType?: SmtpAuthenticationType;
}
export interface UsernamePasswordSmtpConfigurationResource extends SmtpCredentialDetailsResource {
    SmtpLogin?: string;
    SmtpPassword: SensitiveValue;
}
export interface GoogleSmtpConfigurationResource extends SmtpCredentialDetailsResource {
    GoogleAudience?: string;
    GoogleServiceAccount?: string;
}
export interface AzureSmtpConfigurationResource extends SmtpCredentialDetailsResource {
    AzureAudience?: string;
    AzureClientId?: string;
    AzureTenantId?: string;
    AzureScopes?: string;
}
export type SmtpCredentialDetails = UsernamePasswordSmtpConfigurationResource | GoogleSmtpConfigurationResource | AzureSmtpConfigurationResource;
export interface SmtpConfigurationResource extends ResourceWithId {
    SmtpHost: string;
    SmtpPort?: number;
    SendEmailFrom: string;
    EnableSsl: boolean;
    Timeout?: number;
    Details?: SmtpCredentialDetails;
}
export enum SmtpAuthenticationType {
    None = "None",
    UsernamePassword = "UsernamePassword",
    GoogleOAuth = "GoogleOAuth",
    AzureOAuth = "AzureOAuth"
}
export function IsUsingSmtpUsernamePasswordAuth(model: SmtpConfigurationResource): model is SmtpConfigurationResource & {
    Details: UsernamePasswordSmtpConfigurationResource;
} {
    return model.Details?.CredentialType === SmtpAuthenticationType.UsernamePassword;
}
export function IsUsingSmtpGoogleOAuthAuth(model: SmtpConfigurationResource): model is SmtpConfigurationResource & {
    Details: GoogleSmtpConfigurationResource;
} {
    return model.Details?.CredentialType === SmtpAuthenticationType.GoogleOAuth;
}
export function IsUsingSmtpAzureOAuthAuth(model: SmtpConfigurationResource): model is SmtpConfigurationResource & {
    Details: AzureSmtpConfigurationResource;
} {
    return model.Details?.CredentialType === SmtpAuthenticationType.AzureOAuth;
}
